import Evemit from 'evemit';

const eventEmitter = new Evemit();

export default eventEmitter;
